<template>
<div class="container hidden container--current-unit align-items-center">

  <div class="container--current-unit__unit container column justify-content-center align-items-center animation-fade animation-delay-05">
    <span class="unit-color letter-spacing-05">UN<span>{{data.number > 9 ? data.number : `0${data.number}`}}</span></span>
    <small class="saving letter-spacing-05 mobile_hide"><span>Gravando</span> conteúdo</small>
    <div class="container align-items-start width-full max-width mobile_hide">
      <div class="margin-right-10">
        <img src="@/assets/img/card.svg" width="40" class="logo" alt="Minds">
      </div>
      <metaPercentage :percentage="unityDonePercent" height="46" border-radius="4" class="flex-grow-1"/>
    </div>
  </div>
  <div class="container--current-unit__exercices container align-items-center full-height relative">
    <slick ref="slick" :options="slickOptions" class="slick--unit__exercices" v-if="topics.length">
      <div v-for="(topic, index) in topics" :key="index">
        <a @click.prevent="goTopic(topic)">
          <div class="slick--unit__exercices__item container column justify-content-center align-items-center animation-bottom relative"
               :style="{ animationDelay: (index / 5) + 's', cursor: clicked ? 'not-allowed' : 'pointer' }"
               :class="{
                 finish: topic.finished && !isReview,
                 current: ((topic._id == currentTopic._id) && !topic.finished && !unit.finished && !isReview && !student.teens)
                       || (!topic.value && !topic.finished && !isReview && !student.teens)
                       || (isReview && !!topic.value && !student.teens)
                       || (isReview && !topic.value && topic.finished && !student.teens)
                       || (!!student.teens && !topic.finished),
                 todo: ((!topic.finished && (topic._id != currentTopic._id) && !!topic.value) && !isReview && !student.teens)
                    || (!topic.value && !topic.finished && isReview && !student.teens)
                    || (unit.finished && !topic.finished && !!topic.value && !isReview && !student.teens)
                    || (madeOnPresential(topic) && !student.teens)
                    || (revision && !topic.value && !student.teens)
                }">
            <span class="topic-warning" v-if="madeOnPresential(topic)">
              <font-awesome-icon icon="ban"/>
              <p>Presencial</p>
            </span>
            <div class="slick--unit__exercices__item__image container justify-content-center align-items-center">
              <div class="slick--unit__exercices__item__number container justify-content-center align-items-center">
                <span>{{ index + 1 }}</span>
              </div>
              <img :src="require('@/assets/img/units/' + topicImage[index] + '.svg')" width="40" class="logo" :alt="topic.name">
            </div>
            <div class="slick--unit__exercices__item__text container justify-content-center align-items-center">
              <span>{{ topic.name }}</span>
            </div>
            <div class="slick--unit__exercices__item__level container justify-content-center align-items-center">
              <div style="justify-content: space-evenly;" class="item__level--container container align-items-center">
                <div class="item--level" :class="{ check : topic.score >= 25 }"></div>
                <div class="item--level" :class="{ check : topic.score >= 50 }"></div>
                <div class="item--level" :class="{ check : topic.score >= 75 }"></div>
                <div class="item--level" :class="{ check : topic.score == 100 }"></div>
              </div>
            </div>
          </div>
        </a>
      </div>
    </slick>
    <div class="slick--unit__exercices" v-else>
      Loading Topics...
    </div>

<!-- ### INICIO AVISO REVISAO DE UNIDADE -->
    <!-- <div class="bgwhite presential-unit container justify-content-center color-red animation-fade" v-if="isRevision && !isReview && !isRevisionArea">
      <div class="container item full-width">
        <div class="boxmsg item__alert">
          <h1><span/> Attention!</h1>
          <h2 style="font-size: 34.7px!important;">revision class</h2>
        </div>

        <div class="boxmsg item__msg">
          <img src="@/assets/img/icons/blockdash/review.svg" height="60px" alt="Attention">
          <h3 class="container">A unidade <span>{{ currentReview ? currentReview.lesson : '00' }}</span> deve ser revisada para reforçar o conteúdo. Bons estudos!</h3>
        </div>

        <div class="boxmsg item__msgtwo">
          <div class="full-width full-height" v-if="currentReview ? currentReview.ead : false">
            <router-link class="item__btn btn-gradient-green btn btn-full" to="/revision">Ir para área de revisão</router-link>
          </div>
          <span class="item__status btn btn-full" style="font-size: 17px!important;" v-else>
            Esta revisão deve ser feita presencialmente.
          </span>
        </div>
      </div>
    </div> -->
<!-- ### FIM AVISO REVISAO DE UNIDADE -->

<!-- *** INICIO AVISO UNIDADE -->
    <div class="bgwhite presential-unit container justify-content-center color-red animation-fade" v-if="!isUnitClass && !isFinished && !haveSpeakUp && !student.teens">
<!-- PARA TESTE -->
<!--<div class="bgwhite presential-unit container justify-content-center color-red animation-fade" v-else-if="false"> -->
      <div class="container item full-width">
        <div class="boxmsg item__alert">
          <h1><span/> Attention!</h1>
          <h2 style="font-size: 32px !important;">{{ currentClass ? currentClass.lesson_name : '' }}</h2>
        </div>

        <div class="boxmsg item__msg">
          <img src="@/assets/img/icons/blockdash/think.svg" height="60px" alt="Attention">
          <h3 class="container">Você tem uma aula complementar de <span>{{ currentClass ? currentClass.lesson_name : '' }}</span> a ser feita em sua escola. Bons estudos!</h3>
        </div>

        <div class="boxmsg item__msgtwo">
            <div class="item__status btn btn-full" style="font-size: 16px!important;">
              <p>Esta aula deve ser feita presencialmente.</p>
            </div>
        </div>
      </div>
    </div>
<!-- ### FIM AVISO UNIDADE -->

<!-- *** INICIO AVISO SPEAK UP -->
    <div class="bgwhite presential-unit container justify-content-center color-red animation-fade" v-else-if="!isUnitClass && !isFinished && haveSpeakUp && !student.teens">
<!-- PARA TESTE -->
<!--<div class="bgwhite presential-unit container justify-content-center color-red animation-fade" v-else-if="false"> -->
      <div class="container item full-width">
        <div class="boxmsg item__alert">
          <h1><span/> Attention!</h1>
          <h2 style="font-size: 32px !important;">{{ speakupClass.lesson }}</h2>
        </div>

        <div class="boxmsg item__msg">
          <img src="@/assets/img/icons/blockdash/think.svg" height="60px" alt="Attention">
          <h3 class="container">Você tem uma aula complementar de <span>{{ speakupClass ? speakupClass.lesson : '' }}</span> a ser feita.</h3>
        </div>

        <div class="boxmsg item__msgtwo">
            <div class="full-width full-height" style="font-size: 16px!important;">
              <button type="button" class="item__btn btn btn-full btn-gradient-blue" @click="goToSpeakUp()">Go to Speak Up</button>
            </div>
        </div>
      </div>
    </div>
<!-- ### FIM AVISO SPEAK UP -->

<!-- *** INICIO AVISO UNIDADE PRESENCIAL -->
    <div class="bgwhite presential-unit container justify-content-center color-red animation-fade" v-else-if="!unit.ead && !student.teens">
<!-- PARA TESTE -->
<!-- <div class="bgwhite presential-unit container justify-content-center color-red animation-fade" v-else-if="false"> -->

      <div class="container item full-width">
        <div class="boxmsg item__alert">
          <h1><span/> Attention!</h1>
          <h2 style="font-size: 27px">classroom lesson</h2>
        </div>

        <div class="boxmsg item__msg">
          <img src="@/assets/img/icons/blockdash/attention.svg" height="60px" alt="Attention">
          <h3 class="container"><span>{{ currentClass.lesson_name }}</span> deve ser feita <span>presencialmente!</span> Aguardamos você na próxima unidade EAD.</h3>
        </div>

        <div class="boxmsg item__msgtwo">
            <div class="item__status btn btn-full" style="font-size: 14.5px!important;">
              <p>Caso não tenha agendado sua aula, entre em contato com sua escola!</p>
            </div>
        </div>
      </div>

    </div>
<!-- ### FIM AVISO UNIDADE PRESENCIAL -->

<!-- *** INICIO AVISO TIME TO PREPARE ( CONTAGEM DE 5 DIAS ) -->
    <div class="bgwhite presential-unit container justify-content-center color-red animation-fade" v-else-if="inTime && !isFinished && !student.teens">
<!-- PARA TESTE -->
<!-- <div class="bgwhite presential-unit container justify-content-center color-red animation-fade" v-else-if="false"> -->

      <div class="container item full-width">
        <div class="boxmsg item__alert">
          <h1><span/> Attention!</h1>
          <h2 style="font-size: 38.9px!important;">Have a class</h2>
        </div>

        <div class="boxmsg item__msg">
          <img src="@/assets/img/icons/blockdash/prepare.svg" height="60px" alt="Attention">
          <h3 class="container">Para continuar com seus estudos aguarde o <span>tempo abaixo</span> e faça sua preparação para próxima unidade!</h3>
        </div>

        <div class="boxmsg item__msgtwo">
            <div class="item__status btn btn-full" style="font-size: 16px!important;">
              <span style="color: #FF7700!important;" >Wait</span> <span>&nbsp;{{ date.days }}&nbsp;</span> Days <span>&nbsp;{{ date.hours }}&nbsp;</span> Hours <span>&nbsp;{{ date.minutes }}&nbsp;</span> Minutes and <span>&nbsp;{{ date.seconds }}&nbsp;</span>Seconds
            </div>
        </div>
      </div>

    </div>
<!-- ### FIM AVISO TIME TO PREPARE ( CONTAGEM DE 5 DIAS ) -->

<!-- *** INICIO AVISO AULA PRESENCIAL MARCADA E BOTAO CANCELAR -->
    <div class="bgwhite presential-unit container justify-content-center color-red animation-fade has-class" v-else-if="hasClass && !isFinished && !notFinished && !isReview && !student.teens">
<!-- PARA TESTE -->
<!-- <div class="bgwhite presential-unit container justify-content-center color-red animation-fade has-class" v-else-if="false"> -->
      <div class="container item full-width">
        <div class="boxmsg item__alert">
          <h1><span/> Attention!</h1>
          <h2 style="font-size: 29.9px!important;">scheduled class</h2>
        </div>

        <div class="boxmsg item__msg">
          <img src="@/assets/img/icons/blockdash/calendar.svg" height="60px" alt="Attention">
          <h3 class="container">Você tem uma <span>aula agêndada</span> para esta unidade. Caso queira continuar online clicle no botão abaixo.</h3>
        </div>

        <div class="boxmsg item__msgtwo">
            <div class="full-width full-height" style="font-size: 16px!important;">
              <button type="button" class="item__btn btn btn-full btn-gradient-red" @click="cancelClass(currentClass)">Cancel class</button>
            </div>
        </div>
      </div>

    </div>
<!-- ### FIM AVISO AULA PRESENCIAL MARCADA E BOTAO CANCELAR -->

<!-- *** INICIO AVISO TERMINANDO A AULA SER FINALIZADA -->
    <div class="bgwhite presential-unit container justify-content-center column color-red animation-fade has-class" v-else-if="hasClass && !isFinished && notFinished && thisUnitClass.lesson.includes(unit.number) && !isReview && !student.teens">
<!-- PARA TESTE -->
<!-- <div class="bgwhite presential-unit container justify-content-center column color-red animation-fade has-class" v-else-if="false"> -->

      <div class="container item full-width">
        <div class="boxmsg item__alert">
          <h1><span/> Attention!</h1>
          <h2 style="font-size: 25.9px!important;">waiting for the end</h2>
        </div>

        <div class="boxmsg item__msg">
          <img src="@/assets/img/icons/blockdash/hourglass.svg" height="55px" alt="Attention">
          <h3 class="container">O sistema esta aguardando a finalização desta unidade para liberação do próximo conteúdo.</h3>
        </div>

        <div class="boxmsg item__msgtwo">
            <div class="full-width full-height container wrap" style="font-size: 16px!important;">
              <button type="button" style="padding: 0px 30px; margin-right: 15px; flex-basis: 300px; flex-grow:1;" class="item__status btn btn-full">Enquanto isso treine seu inglês na sala virtual.</button>
              <router-link :to="{ name: 'salaVirtual' }" style="flex-basis:180px; flex-grow:1; height: 40px; border-radius: 200px;" class=" btn-gradient-orange btn btn-full">
                Virtual Classroom</router-link>
            </div>
        </div>
      </div>

    </div>
<!-- ### FIM AVISO TERMINANDO A AULA SER FINALIZADA -->

<!-- *** INICIO AVISO INICIAR AULA -->
    <div class="bgwhite presential-unit container justify-content-center color-red animation-fade flex-column" v-else-if="!unit.started && !isFinished && !isReview && !student.teens">
<!-- PARA TESTE -->
<!-- <div class="bgwhite presential-unit container justify-content-center color-red animation-fade flex-column" v-else-if="false"> -->

      <div class="container item full-width">
        <div class="boxmsg item__alert">
          <h1><span/> Attention!</h1>
          <h2 style="font-size: 48.9px!important;">Start unit</h2>
        </div>

        <div class="boxmsg item__msg">
          <img src="@/assets/img/icons/blockdash/start.svg" height="60px" alt="Attention">
          <h3 class="container">Vamos começar a estudar! Clique no botão abaixo para liberar sua aula atual!</h3>
        </div>

        <div class="boxmsg item__msgtwo">
            <div class="full-width full-height" style="font-size: 16px!important;">
              <button type="button" class="item__btn btn btn-full btn-gradient-orange" @click="startUnit()">Start Unit</button>
            </div>
        </div>
      </div>

    </div>
<!-- ### FIM AVISO INICIAR AULA -->

<!-- *** INICIO AVISO TENTATIVAS DE UNIDADE E BOTAO TENTAR NOVAMENTE -->
    <div class="bgwhite presential-unit container justify-content-center color-red animation-fade flex-column" v-else-if="isFinished && !unit.finished && unit.tries > 0 && !student.teens">
<!-- PARA TESTE -->
<!-- <div class="bgwhite presential-unit container justify-content-center color-red animation-fade flex-column" v-else-if="false"> -->

      <div class="container item full-width">
        <div class="boxmsg item__alert">
          <h1><span/> Attention!</h1>
          <h2 style="font-size: 32.9px!important;">Second chance</h2>
        </div>

        <div class="boxmsg item__msg">
          <img src="@/assets/img/icons/blockdash/again.svg" height="60px" alt="Attention">
          <h3 class="container">Você não alcançou 70 pontos, ainda restam {{ 2 - unit.tries }} / 2 chances para finalizar a unidade.</h3>
        </div>

        <div class="boxmsg item__msgtwo">
            <div class="full-width full-height" style="font-size: 16px!important;">
              <button type="button" class="item__btn btn btn-full btn-gradient-orange" @click.prevent="$store.dispatch('unit/reset')">Try again</button>
            </div>
        </div>
      </div>


    </div>
<!-- ### FIM AVISO TENTATIVAS DE UNIDADE E BOTAO TENTAR NOVAMENTE -->

<!-- *** INICIO AVISO MARCA SUA AULA PRESENCIAL -->
    <div class="bgwhite presential-unit container justify-content-center color-red animation-fade flex-column" v-else-if="isFinished && !unit.finished && !student.teens">
<!-- PARA TESTE -->
<!-- <div class="bgwhite presential-unit container justify-content-center color-red animation-fade flex-column" v-else-if="true"> -->

      <div class="container item full-width">
        <div class="boxmsg item__alert">
          <h1><span/> Attention!</h1>
          <h2 style="font-size: 56.9px!important;">You Lost</h2>
        </div>

        <div class="boxmsg item__msg">
          <img src="@/assets/img/icons/blockdash/negative.svg" height="60px" alt="Attention">
          <h3 class="container">Você usou <span> 2 / 2 chances </span>para finalizar a unidade com média. Entre em contato com sua escola.</h3>
        </div>

        <div class="boxmsg item__msgtwo">
          <div class="item__status btn btn-full" style="font-size: 16px!important;">
            <p> Marque sua aula presencialmente para tentar novamente.</p>
          </div>
        </div>
      </div>

    </div>
<!-- ### FIM AVISO MARCA SUA AULA PRESENCIAL -->
  </div>

</div>
</template>

<script>
import { cloneDeep } from 'lodash'
import Slick from 'vue-slick'
import metaPercentage from '@/components/metaPercentage'

import { mapGetters, mapMutations } from 'vuex'

export default {
  name: 'currentUnit',
  props: {
    data: {
      type: Object,
    }
  },
  data () {
    return {
      date: {
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0
      },
      lastClass: 0,
      interval: null,
      slickOptions: {
        prevArrow: '<button type="button" class="btn btn__slickHome btn__slickHome__prev"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 50 80"><defs><style>.a{fill:#fff;}</style></defs><g transform="translate(-55, -130), rotate(180 50 100)"><path class="a" d="M14.8,46a5.444,5.444,0,0,1-3.9-1.6,5.706,5.706,0,0,1-.2-8.1L23.4,23,10.6,9.6a5.729,5.729,0,1,1,8.3-7.9L35.4,19a5.741,5.741,0,0,1,0,7.9L18.9,44.2A5.54,5.54,0,0,1,14.8,46Z"/></g></svg></button>',
        nextArrow: '<button type="button" class="btn btn__slickHome btn__slickHome__next"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 50 80"><defs><style>.a{fill:#fff;}</style></defs><g transform="translate(5, 20), rotate(0 50 100)"><path class="a" d="M14.8,46a5.444,5.444,0,0,1-3.9-1.6,5.706,5.706,0,0,1-.2-8.1L23.4,23,10.6,9.6a5.729,5.729,0,1,1,8.3-7.9L35.4,19a5.741,5.741,0,0,1,0,7.9L18.9,44.2A5.54,5.54,0,0,1,14.8,46Z"/></g></svg></button>',
        slidesToShow: 5,
        slidesToScroll: 5,
        infinite: false,
        dots: false,
        speed: 300,
        responsive: [{
          breakpoint: 900,
          settings: {
            slidesToScroll: 4,
            slidesToShow: 4
          }
        },
        {
          breakpoint: 700,
          settings: {
            slidesToScroll: 3,
            slidesToShow: 3
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToScroll: 2,
            slidesToShow: 2
          }
        },
        {
          breakpoint: 320,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }]
      },
      clicked: false,
      topicImage: {
        0: 'words_attack',
        1: 'all_ears',
        2: 'game',
        3: 'another_brick',
        4: 'assessment'
      },
      speakup: null
    }
  },
  computed: {
    ...mapGetters({
      'student': 'student/GET',
      'books': 'book/getAll',
      'book': 'book/get',
      'units': 'unit/getAll',
      'unit': 'unit/get',
      'unit_id': 'unit/id',
      'classes': 'lesson/getOriginalClasses',
      'lessons': 'lesson/getLessons',
      '_topics_': 'topic/getAll',
      'currentTopic': 'topic/get',
      'toReview': 'lesson/getReview',
      'isReview': 'isReview',
      'revision': 'unit/revision',
      'hasSpeakUp': 'speakup/hasSpeakUp',
      'teensTopics': 'teens/GET_TOPICS',
      'teensBook': 'teens/GET_BOOK',
      'teensUnit': 'teens/GET_UNIT',
    }),
    topics () {
      if (!!this.student.teens)
        return this.teensTopics.map(t => ({ ...t, name: t.title }))

      if (this.isReview) return this._topics_.map(topic => ({
        _id: topic._id,
        name: topic.title,
        value: topic.value,
        score: 0,
        finished: topic.finished,
        subTopics: topic.subTopics,
        // image: topic.title.split(' ').map(str => str.toLowerCase()).join('_')
      }))

      return this._topics_.map(topic => ({
        _id: topic._id,
        name: topic.title,
        value: topic.value,
        score: topic.score,
        finished: topic.finished,
        subTopics: topic.subTopics,
        // image: topic.title.split(' ').map(str => str.toLowerCase()).join('_')
      }))
    },
    isFinished () {
      if (this.isReview)
        return false

      if (this.haveSpeakUp)
        return false

      if (this.currentClass && !this.currentClass.lesson_name.includes('UNIT'))
        return false

      if (this.unit.finished)
        return true

      let finished = 0

      this.topics.forEach(topic => {
        if (topic.finished)
          if (!!topic.value)
            finished++
      })

      return (finished == 4)
    },
    isUnitClass () {
      if (this.isReview)
        return true

      if (this.revision)
        return true

      if (this.haveSpeakup)
        return false

      const book = this.books.find(b => b.id.toUpperCase() == this.student.book_id)

      if (!book || !this.currentClass)
        return false

      return this.currentClass.lesson_name.includes('UNIT')
    },
    speakupClass () {
      return this.classes.find(c => (
        c.status == 'A' &&
        ['A', 'I'].includes(c.status_test) &&
        c.lesson.match('SPEAK UP')
      ))
    },
    haveSpeakUp () {
      if (!this.student.allow_test)
        return false

      if (!this.speakupClass)
        return false

      const startTime = new Date(this.speakupClass.start.split('.').shift()).getTime(),
            current   = Date.now()

      return current >= startTime
    },
    inTime () {
      if (this.isReview)
        return false

      if (!this.unit.ead)
        return false

      const currentIndex = this.units.findIndex(u => this.unit._id == u._id)

      if (currentIndex < 0)
        return false

      const previousUnit = this.units[currentIndex - 1],
            endedDate    = new Date(previousUnit.end),
            endedTime    = endedDate.getTime()

      if (previousUnit.exempt)
        return false

      this.lastClass = endedTime + 432000000 - (endedDate.getHours() * 60 * 60 * 1000)

      return !((this.lastClass - Date.now()) < 0)
    },
    hasClass () {
      if (this.isReview)
        return false

      if (this.revision) {
        if (!this.currentReview)
          return false

        return this.classes.filter(c => (
          c.status == 'A' &&
          c.lesson_id == this.currentReview.lesson_id
        )).length > 0
      }

      return this.thisUnitClass ? true : false
    },
    notFinished () {
      if (this.isReview)
        return false

      if (!this.hasClass)
        return false

      if (!this.thisUnitClass)
        return false

      const startTime = new Date(this.thisUnitClass.start),
            currTime  = Date.now()

      return currTime >= startTime.getTime()
    },
    unityDonePercent () {
      let score = 0

      this.topics.forEach(x => {
        if (x.finished) score += x.score
      })

      const percent = score / this.topics.length

      if (isNaN(percent))
        return "0"

      return percent.toString()
    },
    currentClass () {
      if (this.revision)
        return this.lessons.find(l => l.lesson_id == (this.toReview[0] || {}).lesson_id) || {}

      return this.lessons.find(l => (
        l.lesson_id == this.student.lesson_id &&
        l.order == this.student.lesson_order &&
        l.book_id == this.student.book_id
      ))
    },
    currentReview () {
      return this.revision ? this.toReview[0] : null
    },
    thisUnitClass () {
      const unit = this.classes
                        .filter(c => c.status == 'A')
                        .find(c => parseInt(c.lesson.split(' ').pop()) == this.unit.number)

      if (unit && this.unit.started)
        this.$store.dispatch('unit/stopUnit')

      return unit ? unit : null
    }
  },
  components: {
    metaPercentage,
    Slick
  },
  methods: {
    ...mapMutations({
      setShowLoader: 'setShowLoader'
    }),
    async startReview (review) {
      try {
        this.setShowLoader(true)

        this.$router.push({ name: 'revision' })
      } catch (error) {
        console.warn(error);
      } finally {
        this.setShowLoader(false)
      }
    },
    async cancelClass (lesson) {
      this.setShowLoader(true)

      const current = this.classes.find(c => (
        c.type == 'U' &&
        c.lesson_id == lesson.lesson_id &&
        c.book_id == this.student.book_id
      ))

      if (current)
        await this.$store.dispatch('lesson/removeClass', current.class_id)

      this.setShowLoader(false)
    },
    async startUnit () {
      // console.log('Starting unit');
      this.setShowLoader(true)

      const start = performance.now()

      await this.$store.dispatch('unit/startUnit')
      // console.log(`Start Unit took: ${(performance.now() - start)/1000}`)
      this.setShowLoader(false)
    },
    async goTopic (topic) {
      if (!this.clicked) {
        this.clicked = true

        this.setShowLoader(true)

        if (!this.student.teens) {
          const book      = this.book.title,
                unit      = this.unit.number,
                isCurrent = topic._id == this.currentTopic._id,
                isGame    = !topic.value

          if (this.revision) {
            if (isCurrent || topic.finished) {
              if (!isGame && !topic.finished && !this.unit.exempt)
                await this.$store.dispatch('lesson/getClasses')

              if (!this.inTime && !this.hasClass && !this.unit.exempt && !isGame) {
                await this.$store.dispatch('topic/fetchTopic', topic._id)

                this.$router.push({ name: 'topic-revision', params: { topic: topic.name } })
              }
            }
          } else if (this.isReview) {
            if (!!topic.value) {
              await this.$store.dispatch('topic/fetchTopic', topic._id)

              this.$router.push({ name: 'topic-review', params: { book, unit, topic: topic.name } })
            }
          } else {
            // if (!isGame && !topic.finished && !this.unit.exempt) await this.$store.dispatch('lesson/getClasses')
            if (!this.inTime && !this.hasClass && (!this.unit.exempt || isGame)) {
              if (isCurrent || isGame) {
                if (!isGame)
                  await this.$store.dispatch('lesson/getClasses')

                await this.$store.dispatch('topic/fetchTopic', topic._id)
                this.$router.push({ name: 'topic', params: { book, unit, topic: topic.name } })
              }
            }
          }
        } else {
          const book   = this.teensBook.title,
                unit   = this.teensUnit.number

          await this.$store.dispatch('teens/setTopic', topic._id)
          
          this.$router.push({ name: 'topic', params: { book, unit, topic: topic.name } })
        }

        this.setShowLoader(false)
        this.clicked = false
      }
    },
    setInterval () {
      this.interval = setInterval(() => {
        const distance = this.lastClass - Date.now()

        this.date.days = Math.floor(distance / (1000 * 60 * 60 * 24))
        this.date.hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
        this.date.minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))
        this.date.seconds = Math.floor((distance % (1000 * 60)) / 1000)
      }, 1000)
    },
    toDate (date) {
      const d = new Date(date)
      return d.getTime()
    },
    madeOnPresential (topic) {
      if (this.isReview)
        return false

      if (!topic.value)
        return false

      if (!this.unit.finished)
        return false

      if (!this.unit.started)
        return true
    },
    getPreviousClass (lesson) {
      if (!lesson) return ''

      const sorted_lessons = this.lessons.filter(i => i.book_id == this.student.book_id).sort((a, b) => (a.order - b.order)),
            cur_index      = sorted_lessons.findIndex(l => l.lesson_id == lesson.lesson_id && l.order == lesson.order),
            prev_lesson    = (cur_index < 1) ? '' : sorted_lessons[cur_index - 1].lesson_name

      return prev_lesson
    },
    async goToSpeakUp () {
      if (this.haveSpeakUp) {
        try {
          this.setShowLoader(true)

          await this.$store.dispatch('speakup/getSpeakUp', this.speakupClass.class_id)

          if (!this.hasSpeakUp) {
            await this.$store.dispatch('speakup/addSpeakUp', {
              class_id: this.speakupClass.class_id,
              date: this.speakupClass.start,
              lesson_id: this.speakupClass.lesson_id,
            })

            await this.$store.dispatch('speakup/getSpeakUp', this.speakupClass.class_id)
          }

          if (this.hasSpeakUp)
            this.$router.push(`/speakup/${this.speakupClass.class_id}`)
        } catch (error) {
          console.log(error)
        } finally {
          this.setShowLoader(false)
        }
      }
    }
  },
  watch: {
    unit () {
      this.$nextTick()
    },
    inTime (val) {
      if (val)
        this.setInterval()
      else
        clearInterval(this.interval)
    },
    speakupClass (val) {
      this.speakup = null

      if (val) {
        this.$store.dispatch('speakup/verifySpeakUp', {
          lesson_id: val.lesson_id,
        })
          .then(doc => {
            this.speakup = doc
          })
          .catch(error => {
            console.log(error)
          })
      }
    }
  },
  async beforeMount () {
    await this.$store.dispatch('topic/setTopic')
  },
  async mounted () {
    if (this.inTime)
      this.setInterval()

    if (this.speakupClass) {
      this.$store.dispatch('speakup/verifySpeakUp', {
        lesson_id: this.speakupClass.lesson_id,
      })
        .then(doc => {
          this.speakup = doc
        })
        .catch(error => {
          console.log(error)
        })
    }
  },
  beforeDestroy () {
    if (this.interval)
      clearInterval(this.interval)
  }
}
</script>

<style lang="scss" scoped>


.slick--unit__exercices__item {
    // min-height: 200px;
    padding-top: 13px;
    padding-bottom: 5px;
    display: flex!important;
    justify-content: center;
    align-items: center;
    // cursor: pointer;
    transition: 0.1s;
    font-weight: 300;

    &:hover {
        cursor: pointer;
        // transform: translateY(-5px);
        .slick--unit__exercices__item__image img {
            transform: scale(1.2, 1.2);
        }
    }
    .slick--unit__exercices__item__image {
        img {
            transition: 0.3s;
        }
        transition: 0.1s;
        width: 90px;
        height: 80px;
        background: linear-gradient(to bottom, #E3E3E3, #AAA8A8);
        border-radius: 0 20px 0 0;
        position: relative;
        .slick--unit__exercices__item__number {
            border-radius: 8px;
            width: 25px;
            height: 25px;
            color: #fff;
            font-size: 13px;
            background: #ADADAD;
            border: 2px solid #DADADA;
            position: absolute;
            top: -10px;
            left: -10px;
        }
    }
    .slick--unit__exercices__item__text {
        background: #c0c0c0;
        box-shadow: 0 1px 1px 0 rgba(38,174,191,0.13), 0 5px 4px 0 rgba(38,174,191,0.17), 0 -2px 1px 0 rgba(38,174,191,0.13);
        border-radius: 5px 5px 10px 10px;
        width: 100px;
        height: 24px;
        font-size: 14px;
        color: #757575;
        text-align: center;
        font-size: 12px;
        letter-spacing: .4px;
    }
    .slick--unit__exercices__item__level {
        .item__level--container {
            width: 100px;
            height: 10px;
            margin-top: 10px;
            .item--level {
                width: 16px;
                height: 5px;
                background: #D8D8D8;
                margin: 2px;
                border-radius: 5px;
                &.check {
                    background: #F5A623;
                }
            }
        }
    }
}

.container--current-unit {
    .container--current-unit__unit {
        .max-width {
            max-width: 128px;
        }
        flex-basis: 120px;
        flex-shrink: 100px;
        min-width: 100px;
        margin-right: 10px;
        .unit-color {
            font-size: 46px;
            letter-spacing: .5px;
            line-height: 40px;
            font-weight: bold;
            color: #255F83;
            span {
                color: #04B4BB;
            }
            @media (max-width: 440px) {
              background: #dedede;
              padding: 10px 80px;
              border-radius: 50px;
              margin-bottom: 20px;
             }
        }
    }
    .container--current-unit__exercices {
        flex-basis: 200px;
        max-width: 100%;
        flex-grow: 1;
        .slick--unit__exercices {
            width: 100%;
        }
        @media (max-width: 440px){
          min-height: 220px;
          margin: 0px 0px 40px 0px;
        }
    }
    @media (max-width: 1126px) {
        justify-content: center;
        flex-wrap: wrap;
    }
}

.finish {
    .slick--unit__exercices__item__image {
        background: linear-gradient(to bottom, #00FFB1, #039BA8);
        .slick--unit__exercices__item__number {
            background: #039BA8;
            border-color: #00FFB1;
        }
    }
    .slick--unit__exercices__item__text {
        color: #005D64;
        background: #00FFB1
    }

    .slick--unit__exercices__item__level {
        .item__level--container {
            .item--level.check {
                background: #00FFB1;
            }
        }
    }
}

.current {
    .slick--unit__exercices__item__image {
        background: linear-gradient(to bottom, #FFAC2B, #FF7F26);
        .slick--unit__exercices__item__number {
            background: #FF7F26;
            border-color: #FFAC2B;
        }
    }
    .slick--unit__exercices__item__text {
        color: #750000;
        background: #FFAC2B
    }

    .slick--unit__exercices__item__level {
        .item__level--container {
            .item--level.check {
                background: #FFAC2B;
            }
        }
    }
}

.todo {
    &.slick--unit__exercices__item {
        cursor: not-allowed;
        opacity: 0.5;
        &:hover {
            transform: none;
            .slick--unit__exercices__item__image img {
                transform: none;
            }
        }
    }
}

.saving {
  text-align: center;
  font-size: 12px;
  color: #FF5C00;
  margin-bottom: 5px;
      span {
        color: #255F83
      }
}

 @media (max-width: 440px) {
    .mobile_hide {
      display: none;
      }
  }

.presential-unit {
  cursor: not-allowed;
  align-items: center;
  font-size: 32px;
  width: 100%;
  height: 100%;
  background-color: rgba(#FFF, .85);
  position: absolute;
  top: 0;
  left: 0;
  border-radius: 10px;
   @media (max-width: 440px) {
    height: 250px;
  }
}


.has-class {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  p:first-child {
    margin-bottom: 5px;
  }
}

.topic-warning {
  position: absolute;
  z-index: 100;
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-direction: column;
  font-weight: bold;
  height: calc(100% - 70px);
  color: rgb(199, 3, 29);
  height: 100%;
  width: 100%;
  padding-top: 13px;
  padding-bottom: 21px;
  p {
    width: 100px;
    height: 24px;
    padding: 5px 10px;
    background: rgba(255, 255, 255, 0.6);
    border-radius: 5px 5px 10px 10px;
  }
  svg {
    width: 50px;
    height: 50px;
    background: rgba(255, 255, 255, 0.6);
    padding: 5px;
    border-radius: 50%;
  }
}
:focus {
    outline:none!important;
    outline-color:none!important;
    }

.bgwhite {
    background: white !important;
    }
.letter-spacing-05{
  letter-spacing: .5px;
}

.item{
      flex-wrap: wrap;
      align-items: center;
      height: 100%;

      &__alert {
      // background: orange;
      // align-items: flex-end;
      flex-direction: column;
      padding-left: 30px;
      flex-basis: 35%;
      margin-right: 20px;
      }
      &__msg {
      flex-direction: row;
      align-items: center;
      flex-basis: 50%;
      @media (max-width: 440px) {
        margin-left: 15px;
      }
      }
      &__msgtwo {
      font-weight: 300;
      justify-content: center;
      align-items: center;
      height: 40px!important;
      margin: 5px 20px 23px 20px;
      flex-basis: 100%;
      height: 70px;
      // border: 1px solid blue;
      & p{
        @media (max-width: 440px) {
        white-space: normal;
          }
        }
      }

      &__btn{
        width: 100%;
        height: 100%;
        font-size: 15px!important;
        border-radius: 300px;
        padding: 0px;
        text-transform: uppercase;
        @media (max-width: 440px) {
          margin-top: 20px;
        }
      }

      &__status{
        width: 100%;
        height: 100%;
        padding: 0px;
        color: #797979;
        background: #eaeaea;
        border: 2px solid #b4b4b4;
        border-radius: 300px;
        font-weight: 300;
        justify-content: center;
        align-items: center;
        text-align: center;
        display: flex;
        @media (max-width: 440px){
          padding: 30px;
          margin-top: 30px;
        }
      }
  .boxmsg{
        display: flex;
        justify-content: center;
        flex-grow: 1;
        // flex-basis: 50%;
        // height: 70px;

        h1{
          font-size: 25px;
          font-weight: 400;
          text-transform: uppercase;
          color: orange;
          display: flex;
          align-items: center;
          span{
            height: 7px;
            width: 102px;
            background-color: orange;
            border-radius: 300px;
            margin: 0px 10px 0px 0px;
          }
        }
        h2{
          font-weight: 400;
          letter-spacing: -1px;
          text-transform: uppercase;
          margin-top: -5px;
        }
        h3{
          font-size: 15px;
          font-weight: 200;
          color: gray;
          align-items: center;
          padding-right: 15px;
          span{
            font-weight: 400;
            font-size: 16px;
            color: #ff7f00;
            display: contents;
          }
        }
        img{
          // background-color: white;
          width: 70px;
          margin: 0px 5px 0px 0px;
        }
      }
    }


</style>



// WEBPACK FOOTER //
// src/pages/home/currentUnit.vue